import { MeetingsServiceApi } from '../clients/meetings'
import { API_CONFIG } from '../config'
import { apiClient } from '../http'

// Все запросы идут через nginx (BASE_URL). PURE — модуль без побочных эффектов:
// клиент уходит в чанки экранов, которые его зовут, а не во входной (DEV-2503).
// meetings (DEV-2005): видеовстречи с клиентом — назначение, приглашения,
// записи с расшифровками и черновик квалификации по итогам разговора
export const meetingsApi = /* @__PURE__ */ new MeetingsServiceApi(
  undefined,
  API_CONFIG.BASE_URL,
  apiClient,
)
